import {Component, NgZone} from '@angular/core';
import {AlertController, Events, IonicPage, NavController, NavParams, PopoverController} from 'ionic-angular';
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {CourseVideo} from "../../models/course-video";
import {UserTagProvider} from "../../providers/user-tag/user-tag";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {isNumeric} from "../../../node_modules/rxjs/util/isNumeric";
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {StatusBar} from "@ionic-native/status-bar";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {DatePickerPopoverPage} from "../date-picker-popover/date-picker-popover";
import * as moment from "moment";

/**
 * Generated class for the AppVideoMyWayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-video-my-way',
  templateUrl: 'app-video-my-way.html',
})
export class AppVideoMyWayPage {

  video: CourseVideo;
  values: Map<string, string>;
  position: number = 0;
  allVideos: number = 0;
  doNotProvideAnswers: boolean = false;

  anyValueChanged: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, private tag: UserTagProvider, private progress: UserProgressStateProvider, private apiCourseData: ApiCourseDataProvider, public statusBar: StatusBar, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider, public popoverCtrl: PopoverController, public ngZone: NgZone, public events: Events) {
    console.log('constructor AppVideoQuizPage', this.navParams.data);
    if(!this.navParams.data) {
      this.navCtrl.push(AppDashboardPage)
    }
    this.video = (this.navParams.data as CourseVideo);
    this.values = new Map<string, string>();

    let allEmpty = true;

    for(var k in this.video.myWayQuestions) {
      var vl = this.tag.getValue(this.video.myWayQuestions[k].reference);
      if(vl && vl.replace(/(<([^>]+)>)/ig,"")) {
        allEmpty = false;
      }
      if(isNumeric(vl)) {
        this.video.myWayQuestions[k].response = parseFloat(vl)*10;
      } else {
        this.video.myWayQuestions[k].response = vl;
      }
      this.values.set(this.video.myWayQuestions[k].reference, vl);

      this.video.myWayQuestions[k].dynamicPrefix = this.tag.compile(this.video.myWayQuestions[k].prefix, {})
      this.video.myWayQuestions[k].dynamicBottomText = this.tag.compile(this.video.myWayQuestions[k].bottomText, {})
    }

    if(this.progress.currentProgress.videoId!=this.video.id && allEmpty) {
      this.doNotProvideAnswers = true;
    }
    if(!allEmpty) {
      this.anyValueChanged = true;
    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppVideoMyWayPage');

    this.statusBar.hide();

    for(var k in this.video.myWayQuestions) {
      var vl = this.tag.getValue(this.video.myWayQuestions[k].reference);
      if(vl && this.video.myWayQuestions[k].type == 'date') {
        this.video.myWayQuestions[k].formattedDate = vl;
      }
      else if(isNumeric(vl)) {
        this.video.myWayQuestions[k].response = parseFloat(vl)*10;
      } else {
        this.video.myWayQuestions[k].response = vl;
      }
    }

    var me = this;
    me.allVideos = 0;
    me.position = 0;

    this.apiCourseData.getMyWayCourses().then(videos => {
      videos.map(data => {
        me.allVideos++;
        if(data.id == me.video.id) {
          me.position = me.allVideos;
        }
      })
    });
  }

  ionViewWillLeave() {
    if((window as any).statusBarHiddenByDefault == false) {
      this.statusBar.show();
    }
  }

  handleValueUpdate(event, question) {
    event = event.toString().replace(/(<([^>]+)>)/ig,"").trim();
    this.values.set(question.reference, event);

    if(!event.replace(/(<([^>]+)>)/ig,"")) {
      return ;
    }

    var me = this;
    var payload = [];
    this.video.myWayQuestions.map(q => {
      payload[q.reference] = me.values.get(q.reference);
    })
    for(var k in this.video.myWayQuestions) {
      this.video.myWayQuestions[k].dynamicPrefix = this.tag.compile(this.video.myWayQuestions[k].prefix, payload)
      this.video.myWayQuestions[k].dynamicBottomText = this.tag.compile(this.video.myWayQuestions[k].bottomText, payload)
    }

    this.anyValueChanged = true;
    this.ngZone.run( () => {
      this.doNotProvideAnswers = false;
    })

    console.log(payload);
  }

  generateDynamicText(text: string): string {
    return this.tag.compile(text, {});
  }

  save() {
    var me = this;
    var success = true;
    var payload = {};
    for(var k in this.video.myWayQuestions) {
      var ref = this.video.myWayQuestions[k].reference
      if(!this.values.get(ref)) {
        if(!this.doNotProvideAnswers && !this.anyValueChanged) {
          const alert = this.alertCtrl.create({
            title: this.contentTranslation.translateContent('My way fields are required title'),
            subTitle: this.contentTranslation.translateContent('My way fields are required text'),
            buttons: [
              {
                text: 'OK',
              },
              {
                text: '×',
                cssClass: 'close-button'
              }
            ],
            cssClass: 'ip-alert ip-with-close'
          });
          alert.present();

          return ;
        }
      } else {
        payload[ref] = this.values.get(ref);
      }
    }

    if (!this.doNotProvideAnswers) {
      this.events.publish('my-way:filled');
    }

    console.log(this.progress.currentProgress, this.video.id);
    if(this.progress.currentProgress.videoId==this.video.id) {
      console.log('taskDone update', success);
      this.progress.currentProgress.taskDone = success;
      this.progress.triggerProgressUpdate();
    }
    this.tag.saveChanges(payload);
    this.navCtrl.pop({animate: false});
  }

  openedPopover: any;
  openDatePickerPopover(event, question) {
    this.openedPopover = this.popoverCtrl.create(
      DatePickerPopoverPage,
      {
        payload: question,
        valueUpdated: (selectedDate) => {
          question.response = selectedDate
          question.formattedDate = moment(question.response).format('D. MMMM YYYY');
          this.handleValueUpdate(question.formattedDate, question)
        }
      },
      {cssClass: 'date-picker-popover-container'}
      );
    this.openedPopover.present({
      ev: event,
    });
  }

  closePopover() {
  }

  updateDoNotProviderAnswersCheckbox() {
    this.ngZone.run(() => {
      this.doNotProvideAnswers = !this.doNotProvideAnswers;
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-video-my-way/app-video-my-way.ts